import PropTypes from "prop-types";
import TextInput from "@shared/v2/TextInput";
import Dropdown from "@shared/v2/Dropdown";
import FieldLabel from "@shared/v2/FieldLabel";
import FilterPill from "@shared/v2/FilterPill";
import PlatformCTA from "./PlatformCTA";
import LastWebsiteVisitSelect from "./LastWebsiteVisitSelect";

const DisabledHistoryFields = ({ lastWebsiteVisitOptions, previousSelectedLastWebsiteVisit }) => (
  <div className="tw-flex tw-flex-col tw-gap-[16px] tw-px-[10px]">
    <div className="tw-flex tw-gap-[16px]">
      <PlatformCTA>
        <div className="tw-flex tw-flex-col tw-gap-[8px] tw-flex-1">
          <FieldLabel label="Website Activity" isDisabled />
          <div className="tw-flex tw-flex-wrap tw-gap-[4px]">
            <FilterPill disabled>Property Views</FilterPill>
            <FilterPill disabled>Favorites</FilterPill>
          </div>
        </div>
      </PlatformCTA>
      <LastWebsiteVisitSelect
        options={lastWebsiteVisitOptions}
        previousSelected={previousSelectedLastWebsiteVisit}
      />
    </div>
    <PlatformCTA>
      <div className="tw-flex tw-gap-[16px]">
        <TextInput label="Min Price" disabled />
        <TextInput label="Max Price" disabled />
      </div>
    </PlatformCTA>
    <PlatformCTA>
      <div className="tw-flex tw-items-end tw-gap-[4px]">
        <Dropdown
          label="Bedrooms"
          containerClassName="tw-flex-1"
          id="filters-disabled-history-fields_property-bedrooms"
          placeholder="No Min"
          isDisabled
        />
        <span>-</span>
        <Dropdown containerClassName="tw-flex-1" placeholder="No Max" isDisabled />
      </div>
    </PlatformCTA>
    <PlatformCTA>
      <div className="tw-flex tw-items-end tw-gap-[4px]">
        <Dropdown
          label="Bathrooms"
          containerClassName="tw-flex-1"
          id="filters-disabled-history-fields_property-bathrooms"
          placeholder="No Min"
          isDisabled
        />
        <span>-</span>
        <Dropdown containerClassName="tw-flex-1" placeholder="No Max" isDisabled />
      </div>
    </PlatformCTA>
    <PlatformCTA>
      <TextInput label="Location" disabled />
    </PlatformCTA>
    <hr />
  </div>
);

DisabledHistoryFields.propTypes = {
  lastWebsiteVisitOptions: PropTypes.arrayOf(PropTypes.shape()),
  previousSelectedLastWebsiteVisit: PropTypes.string,
};

DisabledHistoryFields.defaultProps = {
  lastWebsiteVisitOptions: [],
  previousSelectedLastWebsiteVisit: null,
};

export default DisabledHistoryFields;
